import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class ApprConfigService {

  constructor(private http: HttpClient) { }

  saveAppConfig(
    baseUrl: string,
    clobSettingsObj: any,
    clobDataDetails: any[],
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=451s6n`;

    // Build AngularJS-compatible payload structure
    let params: any = _.merge({}, globalService || {}, filterParams);

    // Build clob_data and clob_settings
    const jsonObj = JSON.stringify(clobDataDetails || []);
    const jsonSettings = JSON.stringify(clobSettingsObj || {});

    // Extend with clob_data and clob_settings
    params = _.extend({ clob_data: jsonObj }, params);
    params = _.extend({ clob_settings: jsonSettings }, params);

    // 🔴 CRITICAL: Include ALL required parameters with proper fallback chains (matching action code 451s6n)
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || rowData?.TAX_YEAR || '';
    params.scenario = filterParams?.scenario || globalService?.scenario || rowData?.SCENARIO || '74';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || rowData?.JCD_KEY || '250';
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || rowData?.JCD_TA_KEY || '1250';
    params.activity_key = filterParams?.activity_key || globalService?.activity_key || rowData?.ACTIVITY_KEY || '1349';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || rowData?.SCREEN_KEY || '10765';
    params.screen_type = filterParams?.screen_type || globalService?.screen_type || rowData?.SCREEN_TYPE || 'grid';
    params.is_locked = filterParams?.is_locked || globalService?.is_locked || rowData?.IS_LOCKED || 'N';
    params.issue_id = filterParams?.issue_id || globalService?.issue_id || rowData?.ISSUE_ID || '';
    params.issue_short_desc = filterParams?.issue_short_desc || globalService?.issue_short_desc || rowData?.ISSUE_SHORT_DESC || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || rowData?.ISSUE_ID_FOR_TX_SAVE || '';
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.is_issue_key_enabled = 'N';
    params.filing_group_key = filterParams?.filing_group_key || globalService?.filing_group_key || rowData?.FILING_GROUP_KEY || '1';

    // 🔴 CRITICAL: Build checkLockedbj from rowData (matching payload structure)
    const scenarioKey = parseInt(filterParams?.scenario || globalService?.scenario || rowData?.SCENARIO || '74');
    const consolGroupKey = rowData?.CONSOL_GROUP_KEY || rowData?.FILING_GROUP || rowData?.CONSOL_GROUP_NAME || 
                          filterParams?.consol_group_key || globalService?.consol_group_key || '1';
    
    const checkLockedbj = [{
      "consol_group_key": String(consolGroupKey),
      "scenario_key": scenarioKey
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // Use application/x-www-form-urlencoded
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}
